export const LOGGED_USER = 'MINOSSE_logged_user';
export const LOGGED_USER_PROFILE = 'MINOSSE_logged_user_profile';